import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'pin', 'firstName', 'middleName', 'lastName', 'birthDate', 'gender',
    'mobile', 'clientType', 'memberPin', 'memberName', 'memberBirthDate', 'memberGender'
  ]
  static values = { url: String }

  async populate(event) {
    console.log('testetst')
    const patientId = event.target.value
    if (!patientId) {
      this.clearForm()
      return
    }

    try {
      const url = this.urlValue.replace(':id', patientId)
      const response = await fetch(url, { headers: { 'Accept': 'application/json' } })
      const data = await response.json()
      console.log(data)

      // Patient Fields
      this.pinTarget.value = data.phic_id_number || ''
      this.firstNameTarget.value = data.first_name || ''
      this.middleNameTarget.value = data.middle_name || ''
      this.lastNameTarget.value = data.last_name || ''
      this.birthDateTarget.value = data.birth_date || ''
      this.genderTarget.value = data.gender
      this.mobileTarget.value = data.mobile_number || ''

      // Determine Client Type
      this.clientTypeTarget.value = data.patient_type

      // Member Fields (Nested from Member association)
      if (data.member) {
        this.memberPinTarget.value = data.member.phic_id_number || ''
        this.memberNameTarget.value = `${data.member.first_name} ${data.member.last_name}`.trim()
        this.memberBirthDateTarget.value = data.member.birth_date || ''
        this.memberGenderTarget.value = data.member.gender
      }
    } catch (error) {
      console.error('Error fetching patient:', error)
    }
  }

  clearForm() {
    this.targets.forEach(target => {
      if (target.tagName === 'SELECT') {
        target.selectedIndex = 0
      } else {
        target.value = ''
      }
    })
  }
}
